import Path from "../Path";
import PathPlanJumpDownLeft from "../plan/PathPlanJumpDownLeft";
import PathPlanJumpDownRight from "../plan/PathPlanJumpDownRight";
import PathTemplatePattern from "./PathTemplatePattern";


// PATTERN VALUES:
// S start
// P path
// E end
// X closed
// O open
// 8 open or path
// . ignore

export default class PatternJumpDown1Side2Negligible extends PathTemplatePattern {
    constructor() {
        super([
            'S..',     // start    o|p     o|p
            '..E'      // closed   o|p     end
        ],
        true);  // true to flip left/right
    }

    /**
     * Returns the minimum number of path steps required by this pattern to be applied.
     * @override
     * @returns {number}
     */    
    getMinRequiredPathSteps() {
        return 3;
    }

    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlan(path, pathIndex) {
        const start = path.tiles[pathIndex];

        const targetCol = start.getTileCol() + 2; // end tile is 2 columns to the right of start
        const targetRow = start.getTileRow() + 1; // end tile is one row lower than the start
        const endIndex = this.findTilePathIndex(path, pathIndex + 3, targetCol, targetRow);  // +3: we know the end is at least 3 steps away in the path.
        if (endIndex < 0) {
            return null;
        }

        const end = path.tiles[endIndex];
        const steps = endIndex - pathIndex;

        return new PathPlanJumpDownRight(start, end, steps);
    }

    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlanFlipped(path, pathIndex) {
        const start = path.tiles[pathIndex];
        
        const targetCol = start.getTileCol() - 2; // end tile is 2 columns to the left of start
        const targetRow = start.getTileRow() + 1; // end tile is one row lower than the start
        const endIndex = this.findTilePathIndex(path, pathIndex + 3, targetCol, targetRow);  // +3: we know the end is at least 3 steps away in the path.
        if (endIndex < 0) {
            return null;
        }

        const end = path.tiles[endIndex];
        const steps = endIndex - pathIndex;

        return new PathPlanJumpDownLeft(start, end, steps);
    }

    /**
     * @override
     * @returns {string}
     */
    toString() {
        return 'PatternJumpDown1Side2Negligible';
    }
}